const oidc = {
    logout_success: 'คุณออกจากระบบสำเร็จแล้ว',
};
export default Object.freeze(oidc);
